<script lang="ts">
  import cx from "classnames";
  import OVIcon from "app/components/+shared/OVIcon/OVIcon.svelte";
  import { ZapFilled } from "app/components/+shared/OVIcon";
  import type { Tool } from "./toolSuggestion";

  export let items: Tool[];
  export let command: ({ result }: { result: string }) => void;

  let selectedIndex = 0;

  const onKeyDown = (event: { key: string }) => {
    if (event.key === "ArrowUp") {
      selectedIndex = (selectedIndex + items.length - 1) % items.length;
      return true;
    }

    if (event.key === "ArrowDown") {
      selectedIndex = (selectedIndex + 1) % items.length;
      return true;
    }

    // scroll the selected item into view
    document
      .querySelector(`[data-item="${selectedIndex}"]`)
      ?.scrollIntoView({ behavior: "smooth", block: "center" });

    if (event.key === "Enter") {
      selectItem(selectedIndex);
      return true;
    }
    return false;
  };

  const selectItem = (index: number) => {
    const item = items[index];
    if (item) {
      command({ result: item.name });
    }
  };
</script>

<svelte:window on:keydown={onKeyDown} />

<div
  class="scrollbar-thin max-h-[500px] min-w-[300px] space-y-1 overflow-y-auto rounded-lg border border-black/10 bg-white p-1 shadow-xl focus:outline-none dark:border-white/10 dark:bg-neutral-950"
>
  <div class="ml-0.5 p-2 text-sm font-medium text-neutral-500 dark:text-neutral-400">Tools</div>
  {#each items as item, index (item.name)}
    <button
      data-item={index}
      class={cx(
        "group inline-flex w-full cursor-pointer items-start rounded-md p-3 hover:bg-black/4 dark:hover:bg-white/8",
        {
          "active bg-black/4 dark:bg-white/8 ": index === selectedIndex,
        }
      )}
      on:click|preventDefault|stopPropagation={() => selectItem(index)}
    >
      <div class="flex flex-col items-start gap-0.5 text-left">
        <span class="font-inter text-[13px] font-semibold text-neutral-600 dark:text-neutral-200"
          >{item.name}</span
        >
        {#if item.description}
          <span class="text-xs text-neutral-500 dark:text-neutral-500">{item.description}</span>
        {/if}
        {#if item.parameters && item.parameters.length > 0}
          <div class="mt-1.5 space-y-1.5">
            {#each item.parameters as param}
              <div class="flex shrink-0 gap-1.5">
                <OVIcon
                  icon={ZapFilled}
                  class="mt-[3px] shrink-0 text-cyan-500 dark:text-cyan-500"
                  size="size-3"
                />
                <div class="flex flex-col gap-0.5">
                  <div class="flex gap-0.5">
                    <span class="text-xs font-medium text-neutral-500 dark:text-neutral-300/80">
                      {param.name}:
                    </span>
                    <span class="text-xs font-normal text-neutral-400 dark:text-neutral-500">
                      {param.type}
                    </span>
                  </div>
                  {#if param.description}
                    <span class="text-xs text-neutral-400 dark:text-neutral-500"
                      >{param.description}</span
                    >
                  {/if}
                </div>
              </div>
            {/each}
          </div>
        {/if}
      </div>
    </button>
  {:else}
    <div class="mx-0.5 p-2 text-sm font-medium dark:text-neutral-400">No tools found</div>
  {/each}
</div>
